import axios from 'axios';

const api = axios.create({
    baseURL: import.meta.env.VITE_API_BACKEND_URL,
    withCredentials: true
});

export default api;